var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticClass:"slide",style:({ width: ("" + _vm.width) })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }